import { Tabs } from '@heroui/react';
import { useSearchParams } from 'react-router-dom';
import { ProductListPanel } from './components/ProductListPanel';
import { ResourcesManagement } from './components/ResourcesManagement';
import { AppListPanel } from './components/AppListPanel';
import { OrdersListPanel } from './components/OrdersListPanel';
import { SubscriptListPanel } from './components/SubscriptListPanel';
import { EntitlementGrantListPanel } from './components/EntitlementGrantListPanel';
import { EntitlementLimitUsageListPanel } from './components/EntitlementLimitUsageListPanel';
import { EntitlementBalanceUsageListPanel } from './components/EntitlementBalanceUsageListPanel';

export const BIZ_TAB_PRODUCTS = 'products';
export const BIZ_TAB_RESOURCES = 'resources';
export const BIZ_TAB_APPS = 'apps';
export const BIZ_TAB_ORDERS = 'orders';
export const BIZ_TAB_SUBSCRIPTIONS = 'subscriptions';
export const BIZ_TAB_ENTITLEMENT_GRANTS = 'entitlement-grants';
export const BIZ_TAB_ENTITLEMENT_LIMIT_USAGE = 'entitlement-limit-usage';
export const BIZ_TAB_ENTITLEMENT_BALANCE_USAGE = 'entitlement-balance-usage';

const VALID_TABS = new Set([
  BIZ_TAB_PRODUCTS,
  BIZ_TAB_RESOURCES,
  BIZ_TAB_APPS,
  BIZ_TAB_ORDERS,
  BIZ_TAB_SUBSCRIPTIONS,
  BIZ_TAB_ENTITLEMENT_GRANTS,
  BIZ_TAB_ENTITLEMENT_LIMIT_USAGE,
  BIZ_TAB_ENTITLEMENT_BALANCE_USAGE,
]);

export default function BizPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab') ?? BIZ_TAB_PRODUCTS;
  const selectedKey = VALID_TABS.has(raw) ? raw : BIZ_TAB_PRODUCTS;

  return (
    <div className="flex h-full min-h-0 flex-col bg-background">
      <Tabs
        variant="secondary"
        selectedKey={selectedKey}
        className="flex min-h-0 flex-1 flex-col"
        onSelectionChange={(key) => {
          const next = new URLSearchParams(searchParams);
          if (key === BIZ_TAB_PRODUCTS) {
            next.delete('tab');
          } else {
            next.set('tab', String(key));
          }
          setSearchParams(next, { replace: true });
        }}
      >
        <Tabs.ListContainer className="w-full border-b border-border px-4">
          <Tabs.List
            aria-label="业务管理"
            className="w-max min-w-0 gap-0 border-0"
          >
            <Tabs.Tab id={BIZ_TAB_PRODUCTS} className="w-auto">
              产品管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={BIZ_TAB_RESOURCES} className="w-auto">
              资源管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={BIZ_TAB_APPS} className="w-auto">
              应用管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={BIZ_TAB_ORDERS} className="w-auto">
              订单管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={BIZ_TAB_SUBSCRIPTIONS} className="w-auto">
              订阅管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={BIZ_TAB_ENTITLEMENT_GRANTS} className="w-auto">
              权益授予
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={BIZ_TAB_ENTITLEMENT_LIMIT_USAGE} className="w-auto">
              上限型权益用量
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={BIZ_TAB_ENTITLEMENT_BALANCE_USAGE} className="w-auto">
              余额型权益用量
              <Tabs.Indicator />
            </Tabs.Tab>
          </Tabs.List>
        </Tabs.ListContainer>
        <Tabs.Panel
          id={BIZ_TAB_PRODUCTS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <ProductListPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={BIZ_TAB_RESOURCES}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <ResourcesManagement />
        </Tabs.Panel>
        <Tabs.Panel
          id={BIZ_TAB_APPS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <AppListPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={BIZ_TAB_ORDERS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <OrdersListPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={BIZ_TAB_SUBSCRIPTIONS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <SubscriptListPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={BIZ_TAB_ENTITLEMENT_GRANTS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <EntitlementGrantListPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={BIZ_TAB_ENTITLEMENT_LIMIT_USAGE}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <EntitlementLimitUsageListPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={BIZ_TAB_ENTITLEMENT_BALANCE_USAGE}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <EntitlementBalanceUsageListPanel />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
}
